/**
 * Tiny localStorage helpers for stale-while-revalidate startup data.
 * Failures (quota, private mode, corrupt JSON) are swallowed — callers
 * just get null and fall back to a network fetch.
 */

export const CACHE_KEYS = {
  ACTIVITIES: 'cached_activities_v1',
  WALLET: 'cached_wallet_v1',
  NOTIF: 'cached_notif_v1',
};

export function readCache(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object') return parsed;
  } catch (_) {
    /* ignore corrupt / unavailable storage */
  }
  return null;
}

export function writeCache(key, data) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    if (data == null) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(data));
  } catch (_) {
    /* ignore quota / private mode failures */
  }
}

export function clearCache(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    localStorage.removeItem(key);
  } catch (_) {
    /* ignore */
  }
}

/** Wipe all startup data caches (call on logout). */
export function clearAllDataCaches() {
  Object.values(CACHE_KEYS).forEach(clearCache);
}
